import { isCheckStale } from './monitoring';

/**
 * Monitoring worker liveness (Phase 07 Stage 03). Whether the monitoring worker itself is running,
 * read only from its heartbeat — never from service check results, API or browser activity, or the
 * job library's own tables.
 *
 * The worker records a heartbeat after each successful dispatch run (once a minute). The heartbeat
 * goes stale by the same rule as a check result (A-M3): two missed runs plus the grace period —
 * 2 × 60 s + 120 s = 240 s. Exactly 240 s old is still reporting; anything older is not.
 */
export const WORKER_STATES = ['reporting', 'not_reporting', 'never_reported'] as const;
export type WorkerState = (typeof WORKER_STATES)[number];

/** The dispatch job's cadence: the heartbeat interval. */
export const WORKER_HEARTBEAT_INTERVAL_SECONDS = 60;

/**
 * The worker's state at `now` from its last heartbeat (null when it never reported). A heartbeat
 * time ahead of `now` (clock difference between hosts) is not stale, so it counts as reporting.
 */
export function workerLivenessState(lastSeenAt: Date | null, now: Date): WorkerState {
  if (lastSeenAt === null) return 'never_reported';
  return isCheckStale(lastSeenAt, WORKER_HEARTBEAT_INTERVAL_SECONDS, now)
    ? 'not_reporting'
    : 'reporting';
}
